import { createAction } from '@reduxjs/toolkit';

// This one action will call a reducer in all the slices
// as long as the slice defines rootRest in their extraReducers
export const rootReset = createAction('root/reset');
